import { BaseDto } from '../../core';

export class BuyerUpdateDto extends BaseDto<BuyerUpdateDto> {
  constructor(partial?: any) {
    super(partial);
  }

  email?: string;
  firstName?: string;
  lastName?: string;
  callingCode?: string;
  mobile?: string;
  receiveInfoAgreed?: boolean;
  code?: string;
}
